import type { SxProps } from "@mui/material"
import Box from "@mui/material/Box"

import Container from "@components/container"

export default function PageHeader(props: {
  backgroundColor?: "primary" | "secondary"
  sx?: SxProps
  children: JSX.Element | JSX.Element[]
  isLeftPanelOpen?: boolean
}) {
  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        display: "flex",
        background:
          props?.backgroundColor === "secondary" ? "#FAFAFA" : "white",
        borderBottom: 1,
        alignItems: "center",
        borderColor: "divider",
        maxHeight: "3.5rem",
        minHeight: "3.5rem",
        overflow: "hidden",
        pl: 2,
        zIndex: 98,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        ...(props?.isLeftPanelOpen && {
          transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
          })
        })
      })}
    >
      <Container>
        <Box
          {...props}
          sx={{
            width: "100%",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            ...props?.sx
          }}
        />
      </Container>
    </Box>
  )
}
